import { useDropzone } from 'react-dropzone';
import { useEffect, useState } from "react";
import useReducer from "./reducer";
import styles from './singlePropertyForm.module.css';

const SinglePropertyDropzone = () => {
  const [files, setFiles] = useState([]);
  const [{ }, dispatch] = useReducer();
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    onDrop: acceptedFiles => {
      const newFiles = files.concat(acceptedFiles.map(file => Object.assign(file, {
        preview: URL.createObjectURL(file),
        id: file.name + file.lastModified,
        formatType: file.type,
      })))
      setFiles(newFiles);
      dispatch({ type: "singlePropertyFormInput", payload: { photos: newFiles } })
    }
  });

  const removeFile = file => {
    const newFiles = files
    newFiles.splice(newFiles.indexOf(file), 1)
    setFiles(newFiles)
    dispatch({ type: "singlePropertyFormInput", payload: { photos: newFiles } })
  };

  const thumbs = files.map(file => (
    <div className={styles.Thumb} key={file.name}>
      <div className={styles.ThumbInner}>
        <img className={styles.ThumbImage}
          src={file.preview}
          id={file.id}
          // Revoke data uri after image is loaded
          onLoad={() => { URL.revokeObjectURL(file.preview) }}
        />

      </div>
      <button className={styles.ThumbButton} onClick={() => { removeFile(file) }} >x</button>
    </div>
  ));

  useEffect(() => {
    // Make sure to revoke the data uris to avoid memory leaks, will run on unmount
    return () => files.forEach(file => URL.revokeObjectURL(file.preview));
  }, []);

  return (<>
    <label className={`${styles.TextInputLabel} ${styles.reducedMargin}`}>Upload cover photo</label>
    <p className={styles.TextInputDesc}>We can only display one image to represent your property. If you have additional imagery contained in a brochure or a floor plan, we can include this as a downloadable pdf.</p>
    <div >
      <section {...getRootProps({ className: `${styles.DropzoneContainer} dropzone` })}>
        <input {...getInputProps()} />
        <img src="/icons/file-upload.svg" alt="Close Modal" height="45" width="45" />
        <p>Drag 'n' drop, or click to add files</p>
      </section>
      <aside className={styles.ThumbsContainer}>
        {thumbs}
      </aside>
    </div>
  </>

  );

}


export default SinglePropertyDropzone;